import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  inject,
} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';
import { ReactiveFormsModule, UntypedFormGroup } from '@angular/forms';
import {
  FormlyFieldConfig,
  FormlyFormOptions,
  FormlyModule,
} from '@ngx-formly/core';

export interface IRepeatItemDialogData {
  fields: FormlyFieldConfig[];
  model: Record<string, unknown>;
  formState: unknown;
  title: string;
}

@Component({
  selector: 'app-repeat-item-dialog',
  templateUrl: './repeat-item-dialog.html',
  styleUrl: './repeat-item-dialog.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ReactiveFormsModule,
    FormlyModule,
    MatButton,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
  ],
})
export class RepeatItemDialog implements AfterViewInit {
  private readonly _dialogRef =
    inject<MatDialogRef<RepeatItemDialog, Record<string, unknown> | null>>(
      MatDialogRef,
    );
  private readonly _cdr = inject(ChangeDetectorRef);

  readonly data = inject<IRepeatItemDialogData>(MAT_DIALOG_DATA);

  readonly form = new UntypedFormGroup({});
  readonly options: FormlyFormOptions = { formState: this.data.formState };

  ngAfterViewInit(): void {
    if (this.options.checkExpressions && this.data.fields?.length) {
      for (const field of this.data.fields) {
        this.options.checkExpressions(field);
      }
    }
    this._cdr.detectChanges();
  }

  onOk(): void {
    this.form.updateValueAndValidity();

    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const updatedModel = {
      ...this.data.model,
      ...this.form.getRawValue(),
    };

    this._dialogRef.close(updatedModel);
  }

  onCancel(): void {
    this._dialogRef.close(null);
  }
}
